import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { auth: true },
  },
  {
    path: '/helpdesk/tickets/:id',
    redirect: (to) => `/ticket/${to.params.id}`,
  },
  {
    path: '/ticket/:id',
    name: 'Ticket',
    component: () => import(/* webpackChunkName: "ticket" */ '../views/Ticket.vue'),
    meta: { auth: true },
  },
  {
    path: '/ticket-aanmaken',
    name: 'Create',
    component: () => import(/* webpackChunkName: "create" */ '../views/Create.vue'),
    meta: { auth: true },
  },
  {
    path: '/password/reset/:token',
    name: 'PasswordReset',
    component: () => import(/* webpackChunkName: "password-reset" */ '../views/PasswordReset.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/registreren',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
  },
  {
    path: '/:page',
    name: 'DynamicPage',
    component: () => import(/* webpackChunkName: "dynamic-page" */ '../views/DynamicPage.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "dynamic-page" */ '../views/DynamicPage.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  if (to.matched.some((record) => record.meta.auth) && !loggedIn) {
    next('/login');
    return;
  }

  next();
});

export default router;
